<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Consulta e gerenciamento das Notas Fiscais de Serviço emitidas.</span>
                <br />
                <span class="navigation"
                  >Nota Fiscal {{ this.isEmissaoTesteValidacao ? '(Teste e Validação)' : '' }} > Consulta</span
                >
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <Message severity="error" v-if="isEmissaoTesteValidacao"
            >Atenção! Tela de Consulta para Testes e Validações!</Message
          >
          <exportar-notas-fiscais />
          <error-list :erros="erros" />
          <cancelar-nota-fiscal />
          <enviar-email-nota-fiscal />
          <carta-correcao-nota-fiscal />
          <consulta-declaracoes-nota-fiscal />
          <analise-cancelamento-nota-fiscal />

          <div class="row">
            <div class="col-md-2 col-lg-1 mb-3">
              <span class="p-fluid">
                <InputText
                  type="text"
                  id="filtroNumero"
                  v-model="filtroNumero"
                  placeholder="Número"
                  autocomplete="off"
                  @keyup.enter="pesquisar"
                />
              </span>
            </div>
            <div class="col-md-1 col-lg-1 mb-3">
              <span class="p-fluid">
                <InputText
                  type="text"
                  id="filtroRpsNumero"
                  v-model="filtroRpsNumero"
                  title="Número RPS"
                  placeholder="Número RPS"
                  autocomplete="off"
                  @keyup.enter="pesquisar"
                />
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataIni"
                  name="dataFim"
                  v-model="dataFatoGeradorIni"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Data Inicial"
                  @keyup.enter="pesquisar"
                  v-maska="'##/##/####'"
                />
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataFim"
                  name="dataFim"
                  v-model="dataFatoGeradorFim"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Data Final"
                  @keyup.enter="pesquisar"
                  v-maska="'##/##/####'"
                />
              </span>
            </div>
            <div class="col-md-12 col-lg-4 mb-3">
              <span class="p-fluid">
                <AutoComplete
                  id="tomador"
                  v-model="selectedPessoa"
                  :dropdown="true"
                  :suggestions="filteredPessoas"
                  @complete="searchPessoa($event)"
                  @keyup.enter="pesquisar"
                  field="detail"
                  placeholder="CPF/CNPJ/Nome Tomador"
                />
              </span>
            </div>
            <div class="col-md-2 mb-2">
              <span class="p-fluid">
                <Dropdown
                  id="situacao"
                  v-model="filtroSituacao"
                  :options="filtroSituacoes"
                  optionLabel="name"
                  title="Selecione uma Situação"
                  placeholder="Selecione uma Situação"
                />
              </span>
            </div>
          </div>

          <div class="row" v-if="showFilterIntermediario">
            <div class="col-md-12 col-lg-4 mb-3">
              <span class="p-fluid">
                <AutoComplete
                  id="intermediario"
                  v-model="selectedIntermediario"
                  :dropdown="true"
                  :suggestions="filteredIntermediario"
                  @complete="searchIntermediario($event)"
                  @keyup.enter="pesquisar"
                  field="detail"
                  placeholder="CPF/CNPJ/Nome Intermediário"
                />
              </span>
            </div>
          </div>

          <div class="mb-2">
            <Button
              @click="pesquisar()"
              label="Pesquisar"
              type="button"
              class="p-button-primary mr-2"
              icon="pi pi-search"
              :disabled="loading"
            />
            <Button
              class="btn btn-primary mr-2"
              type="button"
              id="dropdownMenuButton"
              icon="pi pi-angle-down"
              label="Imprimir"
              data-toggle="dropdown"
              title="Imprimir"
              aria-haspopup="true"
              aria-expanded="false"
              :disabled="loading"
              v-if="!isEmissaoTesteValidacao"
            ></Button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirConsultaNotaFiscal()">
                <span class="pi pi-print mr-2"></span>Notas Fiscais
              </button>
              <button
                class="dropdown-item"
                type="button"
                :disabled="loading"
                @click="imprimirConsultaNotasCanceladas()"
              >
                <span class="pi pi-print mr-2"></span>Notas Fiscais Canceladas
              </button>
              <button
                class="dropdown-item"
                type="button"
                :disabled="loading"
                v-show="!notaAvulsa && !devedorContumaz"
                @click="imprimirNotaFiscalAgrupadas()"
              >
                <span class="pi pi-print mr-2"></span>Relação de Notas Fiscais
              </button>
              <button
                class="dropdown-item"
                type="button"
                :disabled="loading"
                v-show="!notaAvulsa && !devedorContumaz"
                @click="imprimirDanfseAgrupadas()"
              >
                <span class="pi pi-print mr-2"></span>Relação de DANFSE
              </button>
              <button
                class="dropdown-item"
                type="button"
                :disabled="loading"
                v-show="!notaAvulsa && !devedorContumaz"
                @click="imprimirRelacaoRetencoesNfse()"
              >
                <span class="pi pi-print mr-2"></span>Relação de Notas/Impostos Federais
              </button>
              <button
                class="dropdown-item"
                type="button"
                :disabled="loading"
                v-show="notaAvulsa"
                @click="imprimirConsultaNotaFiscalAvulsaDam()"
              >
                <span class="pi pi-print mr-2"></span>Relação de DAM de Notas Fiscais Avulsas
              </button>
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirLivroFiscal()">
                <span class="pi pi-print mr-2"></span>Livro Fiscal
              </button>
              <button class="dropdown-item" type="button" :disabled="loading" @click="imprimirRelacaoChaveValidacao()">
                <span class="pi pi-print mr-2"></span>Relação de Chaves de Validação
              </button>
            </div>

            <Button
              @click="exportar()"
              label="Exportar Notas Fiscais"
              type="button"
              class="p-button-primary mr-2"
              icon="pi pi-download"
              :disabled="loading"
              v-show="!notaAvulsa && !isEmissaoTesteValidacao"
            />
            <router-link to="/consultaNfseRps">
              <Button
                type="button"
                icon="pi pi-file"
                label="Lotes de RPS"
                title="Lotes de RPS"
                :disabled="loading"
                class="p-button-primary mr-2"
                v-show="!isEmissaoTesteValidacao"
              />
            </router-link>
            <router-link
              to="/consultaNfseNacionalTeste"
              v-if="
                currentUser &&
                  currentUser.usuario.idBolAdmin &&
                  (habilitarNotaNacional || isEmissaoTesteValidacao) &&
                  isEmissaoTesteValidacao
              "
            >
              <Button
                type="button"
                icon="pi pi-file"
                label="Integração Nota Nacional"
                title="Integração Nota Nacional"
                :disabled="loading"
                class="p-button-primary mr-2"
              />
            </router-link>
            <router-link
              to="/consultaNfseNacional"
              v-if="
                currentUser &&
                  currentUser.usuario.idBolAdmin &&
                  (habilitarNotaNacional || isEmissaoTesteValidacao) &&
                  !isEmissaoTesteValidacao
              "
            >
              <Button
                type="button"
                icon="pi pi-file"
                label="Integração Nota Nacional"
                title="Integração Nota Nacional"
                :disabled="loading"
                class="p-button-primary mr-2"
              />
            </router-link>
          </div>

          <hr />

          <div class="row pr-3 pl-3">
            <DataTable :value="nfseList" :paginator="true" :rows="10" :autoLayout="true" ref="dt">
              <template #empty>Nenhum resultado encontrado.</template>
              <Column>
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button
                      class="btn btn-primary"
                      type="button"
                      id="dropdownMenuButton"
                      icon="pi pi-angle-down"
                      data-toggle="dropdown"
                      title="Opções"
                      aria-haspopup="true"
                      aria-expanded="false"
                    ></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        v-show="
                          exibirEmissaoDam(
                            slotProps.data.damPago,
                            slotProps.data.situacao,
                            slotProps.data.idBolDevedorContumaz,
                            slotProps.data.notaAvulsa,
                          )
                        "
                        @click="carregarVencimentoBoleto(slotProps.data.dataFatoGerador, slotProps.data.id)"
                      >
                        <span class="pi pi-fw pi-calendar mr-2"></span>{{ labelDam }}
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        v-if="
                          exibirImpressao(slotProps.data.damPago, slotProps.data.notaAvulsa) &&
                            (slotProps.data.transmitidoNacional === 'I' || slotProps.data.transmitidoNacional === 'M')
                        "
                        @click="visualizarDanfse(slotProps.data.id)"
                      >
                        <span class="pi pi-download mr-2"></span>DANFSE
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        v-if="
                          exibirImpressao(slotProps.data.damPago, slotProps.data.notaAvulsa) &&
                            slotProps.data.transmitidoNacional !== 'I' && slotProps.data.transmitidoNacional !== 'M'
                        "
                        @click="visualizar(slotProps.data.id, slotProps.data.numero)"
                      >
                        <span class="pi pi-search mr-2"></span>Visualizar
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        v-show="
                          exibirImpressao(slotProps.data.damPago, slotProps.data.notaAvulsa) &&
                            slotProps.data.transmitidoNacional !== 'I' && slotProps.data.transmitidoNacional !== 'M'
                        "
                        @click="download(slotProps.data.id)"
                      >
                        <span class="pi pi-download mr-2"></span>Download
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        v-show="
                          exibirImpressao(slotProps.data.damPago, slotProps.data.notaAvulsa) &&
                            slotProps.data.transmitidoNacional === 'S'
                        "
                        @click="openDanfse(slotProps.data.chaveNfseNacional)"
                      >
                        <span class="pi pi-download mr-2"></span>DANFSE
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        @click="downloadXml(slotProps.data.id)"
                        v-show="exibirExportarXml(slotProps.data.damPago, slotProps.data.idBolDevedorContumaz)"
                      >
                        <span class="pi pi-download mr-2"></span>Exportar XML
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="
                          loading || slotProps.data.situacao == 'Cancelada' || slotProps.data.situacao == 'Substituída'
                        "
                        v-show="exibirEnviarEmail(slotProps.data.damPago, slotProps.data.idBolDevedorContumaz)"
                        @click="enviarEmail(slotProps.data.id)"
                      >
                        <span class="pi pi-envelope mr-2"></span>Enviar por E-mail
                      </button>

                      <div class="dropdown-divider" />

                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="
                          loading ||
                            slotProps.data.situacao == 'Cancelada' ||
                            slotProps.data.situacao == 'Substituída' ||
                            inativo || isBloqueado
                        "
                        v-show="
                          exibirCartaCorrecao &&
                            exibirBotaoCartaCorrecao(
                              slotProps.data.damPago,
                              slotProps.data.idBolDevedorContumaz,
                              currentUser.usuario.idBolAdmin,
                            )
                        "
                        @click="cartaCorrecaoNotaFiscal(slotProps.data)"
                      >
                        <span class="pi pi-pencil mr-2"></span>Carta de Correção
                      </button>

                      <div
                        class="dropdown-divider"
                        v-show="
                          exibirBotaoCartaCorrecao(
                            slotProps.data.damPago,
                            slotProps.data.idBolDevedorContumaz,
                            currentUser.usuario.idBolAdmin,
                          )
                        "
                      />

                      <button
                        class="dropdown-item"
                        type="button"
                        v-show="exibirBotaoCancelamento(slotProps.data.damPago, currentUser.usuario.idBolAdmin)"
                        :disabled="
                          loading ||
                            slotProps.data.situacao == 'Cancelada' ||
                            slotProps.data.situacao == 'Substituída' ||
                            slotProps.data.situacao == 'Em análise de Cancelamento' ||
                            inativo || isBloqueado
                        "
                        @click="cancelarNotaFiscal(slotProps.data)"
                      >
                        <span class="pi pi-times mr-2"></span>Cancelar
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        v-show="currentUser.usuario.idBolAdmin"
                        :disabled="
                          loading ||
                            slotProps.data.situacao == 'Cancelada' ||
                            slotProps.data.situacao == 'Substituída' ||
                            inativo || isBloqueado
                        "
                        @click="cancelarNotaFiscalDireta(slotProps.data)"
                      >
                        <span class="pi pi-times mr-2"></span>Cancelar Nota Prazo Vencido
                      </button>
                      <button
                        class="dropdown-item"
                        type="button"
                        v-show="notaAvulsa != true"
                        :disabled="
                          loading ||
                            slotProps.data.situacao == 'Cancelada' ||
                            slotProps.data.situacao == 'Substituída' ||
                            slotProps.data.situacao == 'Em análise de Cancelamento' ||
                            inativo || isBloqueado
                        "
                        @click="substituirNotaFiscal(slotProps.data)"
                      >
                        <span class="pi pi-refresh mr-2"></span>Substituir
                      </button>
                      <div class="dropdown-divider" />
                      <button
                        class="dropdown-item"
                        type="button"
                        :disabled="loading"
                        v-show="exibirConsultaDeclaracao && !notaAvulsa && !isEmissaoTesteValidacao"
                        @click="consultaDeclaracoesNfse(slotProps.data.id)"
                      >
                        <span class="pi pi-file-o mr-2"></span>Consulta de Declarações
                      </button>

                      <div class="dropdown-divider" v-show="notaAvulsa != true && currentUser.usuario.idBolAdmin" />
                      <button
                        class="dropdown-item"
                        type="button"
                        v-show="notaAvulsa != true && currentUser.usuario.idBolAdmin && !isEmissaoTesteValidacao"
                        :disabled="
                          loading ||
                            slotProps.data.situacao == 'Cancelada' ||
                            slotProps.data.situacao == 'Substituída' ||
                            slotProps.data.situacao == 'Em análise de Cancelamento' ||
                            inativo || isBloqueado
                        "
                        @click="analiseCancelamento(slotProps.data)"
                      >
                        <span class="pi pi-pencil mr-2"></span>Análise Cancelamento/Substituição
                      </button>
                      <div
                        class="dropdown-divider"
                        v-show="
                          currentUser.usuario.idBolAdmin &&
                            slotProps.data.situacao === 'Cancelada' &&
                            !isEmissaoTesteValidacao
                        "
                      />
                      <button
                        class="dropdown-item"
                        type="button"
                        v-show="
                          currentUser.usuario.idBolAdmin &&
                            slotProps.data.situacao === 'Cancelada' &&
                            !isEmissaoTesteValidacao
                        "
                        :disabled="loading || inativo || isBloqueado"
                        @click="confirmaDesfazerCancelamento(slotProps.data.id)"
                      >
                        <span class="pi pi-pencil mr-2"></span>Desfazer Cancelamento Nota Fiscal
                      </button>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="numero" header="Número" bodyStyle="text-align:right"></Column>
              <Column field="rpsNumero" header="Número RPS" bodyStyle="text-align:right"></Column>
              <Column field="competenciaFormatada" header="Competência" bodyStyle="text-align:center"></Column>
              <Column field="dataGeracaoFormatada" header="Geração" bodyStyle="text-align:center"></Column>
              <Column headerStyle="min-width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
              </Column>
              <Column headerStyle="min-width: 20em" field="tomadorDadosDetail" header="Tomador"></Column>
              <Column
                field="tipoRecolhimentoFormatado"
                header="Retido"
                headerStyle="min-width: 5em"
                bodyStyle="text-align:center"
              ></Column>
              <Column field="situacao" header="Situação" bodyStyle="text-align:center"></Column>
              <template #footer>
                <div style="text-align: right">
                  <Button
                    icon="pi pi-external-link"
                    label="Exportar para XLS"
                    @click="imprimirExcel()"
                    v-if="!isEmissaoTesteValidacao"
                  />
                </div>
              </template>
            </DataTable>
            <div class="data-limit-notice">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="notice-icon"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              <p class="notice-text">
                A presente visualização está limitada aos 100 registros mais recentes. A listagem completa de notas está
                disponível através dos relatórios em formato PDF ou Excel.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Aviso" :visible.sync="displayAtivaNota" :style="{ width: '30vw' }" :modal="true">
      Confirma a reativação da nota fiscal?
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="desfazerCancelamento()" class="mr-2" />
          </div>
          <div>
            <Button label="Não" icon="pi pi-times" @click="displayAtivaNota = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      :visible.sync="displayVencBoleto"
      :style="{ width: '42vw' }"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
      <h1 class="titulo-header">
        DAM Nota Fiscal
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="displayVencBoleto = false"
        />
      </h1>
      <br />
      <div class="col-md-4 mb-8">
        <label for="dataVencBoleto">Data de Vencimento: *</label>
        <span class="p-fluid">
          <CustomCalendar
            :key="keyVencBoleto"
            id="dataVencBoleto"
            name="dataVencBoleto"
            v-model="dataVencimento"
            :showIcon="true"
            dateFormat="dd/mm/yy"
            v-maska="'##/##/####'"
          />
        </span>
      </div>
      <hr />
      <div>
        <div class="row">
          <div class="mb-2">
            <Button
              label="Gerar DAM"
              icon="pi pi-check"
              class="mr-2"
              v-show="damGerado != 'S'"
              @click="gerarDamNotaAvulsa()"
              :disabled="loading"
            />
          </div>
          <div class="mb-2">
            <Button
              label="Imprimir DAM"
              icon="pi pi-print"
              v-show="damGerado == 'S'"
              @click="imprimirBoleto()"
              :disabled="loading"
              class="mr-2"
            />
          </div>
        </div>
        <div v-if="damGerado == 'S' && habilitarPix" class="row">
          <div class="mb-2">
            <Button
              type="button"
              label="Pagar com PIX"
              title="Pagar com PIX"
              class="p-button-outlined mr-2"
              icon="pi pix-icon"
              style="margin-right: 0.5em"
              :disabled="loading"
              @click="criarPagamentoPix()"
              v-show="damGerado == 'S' && habilitarPix"
            ></Button>
          </div>
          <div class="mb-2">
            <Button
              label="Imprimir DAM PIX"
              class="p-button-outlined mr-2"
              icon="pi pix-icon"
              v-show="damGerado == 'S'"
              @click="imprimirBoletoPix()"
              :disabled="loading"
            />
          </div>
          <div class="mb-2">
            <Button
              title="Consultar Pagamento PIX"
              label="Consultar Pagamento PIX"
              icon="pi pi-search"
              style="margin-right: 0.5em"
              @click="consultarPagamentoPix()"
              v-show="damGerado == 'S' && habilitarPix"
              class="mr-2"
            />
          </div>
        </div>
        <div class="row">
          <div class="mb-2">
            <Button
              label="Cancelar DAM"
              icon="pi pi-print"
              v-show="damGerado == 'S' && showCancDAMPetro"
              @click="cancelarDamNotaAvulsa()"
              :disabled="loading"
              class="p-button-danger mr-2"
            />
            <Button label="Fechar" icon="pi pi-times" @click="hideVencBoleto()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showPix" :style="{ width: '40vw' }" :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-2">
            <QRCanvas :options="optionsPix" />
          </div>
          <div class="col-md-6 mb-2">
            <div style="padding-top: 20px">
              Utilize o App de sua Instituição Financeira, na opção PIX escolha pagar com QR Code, confirme os dados e
              realize o Pagamento. <br />
              <br /><span style="font-weight: bold"
                >Valor Total: {{ this.pixGerado ? this.pixGerado.valorFormatado : 0 }}</span
              >
            </div>
          </div>
        </div>
        <div class="row" v-if="this.pixGerado && this.pixGerado.qrCode">
          <div class="col-md-12 mb-2">
            <Button label="Copiar Código PIX" icon="pi pi-copy" @click="copiarPix()" />
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="Fechar" icon="pi pi-times" @click="showPix = false" class="p-button-danger" />
      </template>
    </Dialog>
    <Dialog class="test-box" :visible.sync="showBloqSubstituicaoNota" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Substituição de Nota Fiscal
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="showBloqSubstituicaoNota = false"
        />
      </h1>
      <br />
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p class="mensagem-substituicao">{{ mensagemSubstituicaoPrazo }}</p>
          </div>
        </div>
        <div class="row" v-if="utilizarTermoSubstituicao">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Observação: *</label>
            <span class="p-fluid">
              <textarea v-model="obsSubstituicao" rows="5" maxlength="255" />
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button
              @click="showBloqSubstituicaoNota = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
            <Button
              @click="emitirTermo()"
              href="#topo"
              type="button"
              label="Emitir Termo de Substituição"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-file"
              :disabled="loading"
              v-if="utilizarTermoSubstituicao"
            />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="displayDanfse" :style="{ width: '40vw' }" :modal="true">
      <h1 class="titulo-header">
        Consultar DANFSE
        <Button
          id="icon-close-modals"
          icon="pi pi-times"
          class="p-button-rounded p-button-text"
          @click="displayDanfse = false"
        />
      </h1>
      <br />
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 mb-2">
            Acesse o link abaixo e efetue a consulta pela Chave de Acesso Nacional: <br />
            <span style="font-weight: bold"
              ><a :href="this.linkConsultaNacional" target="_blank">{{ this.linkConsultaNacional }}</a></span
            >
          </div>
        </div>
        <br />
      </div>

      <hr />
      <Button label="Fechar" icon="pi pi-times" @click="displayDanfse = false" class="p-button-danger" />
    </Dialog>

    <Toast style="width: 700px;" position="top-center" group="cb">
      <template #message="slotProps">
        <div class="flex flex-column">
          <div class="text-center">
            <i class="pi pi-info-circle" style="font-size: 3rem"></i>
            <h4 style="font-weight: bold">{{ slotProps.message.summary }}</h4>
            <p class="msg-export">{{ slotProps.message.detail }}</p>
            <p class="msg-export">
              Exportar Notas Fiscais &#8594; Exportação Assíncrona.
            </p>
          </div>
        </div>
      </template>
    </Toast>
  </div>
</template>
<script>
import { maska } from 'maska';
import RegimeService from '../services/tributario/regime.service';
import NotaFiscalTesteService from '../services/nfse/notafiscalteste.service';
import NotaFiscalService from '../services/nfse/notafiscal.service';
import NotaFiscalAvulsaService from '../services/nfse/notafiscalavulsa.service';
import PessoaService from '../services/nfse/pessoa.service';
import ExportarNotasFiscais from '../components/emissaoNfse/ExportarNotasFiscais';
import CancelarNotaFiscal from '../components/emissaoNfse/CancelarNotaFiscal';
import AnaliseCancelamentoNotaFiscal from '../components/emissaoNfse/AnaliseCancelamentoNotaFiscal';
import CartaCorrecaoNotaFiscal from '../components/emissaoNfse/CartaCorrecaoNotaFiscal';
import ConsultaDeclaracoesNotaFiscal from '../components/emissaoNfse/ConsultaDeclaracoesNotaFiscal';
import EnviarEmailNotaFiscal from '../components/emissaoNfse/EnviarEmailNotaFiscal';
import ReportService from '../services/report.service';
import money from '../conf/config.money';
import LoginService from '../services/acesso/login.service';
import { QRCanvas } from 'qrcanvas-vue';
import CustomCalendar from '../components/global/CustomCalendar.vue';

export default {
  directives: { maska },
  name: 'ConsultaNfse',
  props: {
    testeValidacao: Boolean,
  },
  watch: {
    $route(to, from) {
      //Força reload quando alterna entre as páginas de emissão, pois as duas rotas usam o mesmo componente.
      if (
        (to.path == '/consultaNfse' && from.path == '/consultaNfseTeste') ||
        (to.path == '/consultaNfseTeste' && from.path == '/consultaNfse')
      ) {
        this.pesquisar();
      }
    },
  },
  components: {
    ExportarNotasFiscais,
    CancelarNotaFiscal,
    EnviarEmailNotaFiscal,
    CartaCorrecaoNotaFiscal,
    ConsultaDeclaracoesNotaFiscal,
    AnaliseCancelamentoNotaFiscal,
    QRCanvas,
    CustomCalendar,
  },

  data() {
    return {
      money: money,
      inativo: false,
      display: false,
      displayAtivaNota: false,
      loading: false,
      exibirCartaCorrecao: true,
      filtroEmissao: '',
      filtrosEmissao: [
        { name: 'Notas Prestadas', key: 'P' },
        { name: 'Notas Tomadas', key: 'T' },
      ],
      filtroNumero: '',
      filtroRpsNumero: '',
      filtroSituacao: '',
      filtroSituacoes: [
        { name: 'Todos', key: 'T' },
        { name: 'Ativa', key: 'A' },
        { name: 'Cancelada', key: 'C' },
        { name: 'Substituida', key: 'S' },
      ],
      erros: [],
      nfseList: [],
      listID: [],
      nfseId: null,
      currentUser: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      filteredPessoas: null,
      filteredIntermediario: null,
      selectedPessoa: null,
      selectedIntermediario: null,
      notaAvulsa: null,
      damGerado: null,
      displayVencBoleto: false,
      keyVencBoleto: 1,
      dataVencimento: null,
      idNotaAvulsaSelecionada: null,
      observacaoClienteNfse: false,
      habilitarPix: false,
      showPix: false,
      optionsPix: {
        cellSize: 5,
        data: 'hello',
      },
      pixGerado: null,
      devedorContumaz: false,
      labelDam: 'DAM Nota Fiscal Avulsa',
      exibirConsultaDeclaracao: true,
      mensagemSubstituicaoPrazo: null,
      showBloqSubstituicaoNota: false,
      utilizarTermoSubstituicao: false,
      obsSubstituicao: '',
      showCopiaNota: false,
      showFilterIntermediario: false,
      showCancDAMPetro: true,
      cancDamPetrolina: false,
      habilitarNotaNacional: false,
      displayDanfse: false,
      linkConsultaNacional: null,
      chaveNotaNacional: null,
      apresentacao: false,
    };
  },

  mounted() {
    document.getElementById('filtroNumero').focus();
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    if (this.currentUser.configuracao && this.currentUser.configuracao.idBolModeloFechamento === 'E') {
      this.exibirConsultaDeclaracao = false;
    }
    this.habilitarNotaNacional = this.isEmissaoTesteValidacao
      ? true
      : this.currentUser.configuracao.idBolIntegraNfseNacional === 'S';
    this.habilitarPix = this.currentUser.configuracao.idBolUtilizarPix === 'S';
    this.inativo = this.currentUser && this.currentUser.contribuinte ? !this.currentUser.contribuinte.ativo : false;
    this.notaAvulsa = this.currentUser.emiteNotaAvulsa;
    this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === 'S';
    this.dataVencimento = new Date();
    this.devedorContumaz =
      !this.notaAvulsa &&
      this.currentUser &&
      this.currentUser.contribuinte &&
      this.currentUser.contribuinte.devedorCostumaz &&
      this.currentUser.contribuinte.devedorCostumaz === 'S';
    if (this.devedorContumaz) {
      this.labelDam = 'DAM Nota Fiscal';
    }
    this.pesquisar();
    if (
      this.currentUser.usuario.idCliente === '2471EF3C1697358D802D6B5151D4CF0B' ||
      this.currentUser.usuario.idCliente === '479FD7C92756B652D3A061F3A370CC36' ||
      this.currentUser.usuario.idCliente === '9DFDF7BDBB4580917C42BA8F7E4A5477' ||
      this.currentUser.usuario.idCliente === '2cad11c7-32f8-4ebd-a049-7355df3f64f6'
    ) {
      this.exibirCartaCorrecao = false;
    } else if (
      this.currentUser.configuracao.idBolCartaCorrecao &&
      this.currentUser.configuracao.idBolCartaCorrecao === 'D'
    ) {
      this.exibirCartaCorrecao = false;
    }

    if (this.currentUser.usuario.idCliente === '3d6adeff-3f83-4033-8b16-3f5d42fccd1a') {
      this.showCancDAMPetro = false;
      this.cancDamPetrolina = true;
    }
    this.filtroEmissao = this.filtrosEmissao[0];
    setTimeout(async () => {
      this.regimes = await RegimeService.findAllRegimes(this.currentUser.usuario.idCliente);
    }, 250);
    //desativada linha abaixo.. se houver outro edital retornar
    //this.utilizarTermoSubstituicao = (this.$apresentacao ? this.$apresentacao : false);
    this.apresentacao = (this.$apresentacao ? this.$apresentacao : false);
    this.diasPrazoSubstituicao = this.currentUser.configuracao.nfPrazoDiasSubstituicao || 0;

    this.exibeIntermediario();
  },

  methods: {
    openDanfse(chaveNfseNacional) {
      this.chaveNotaNacional = chaveNfseNacional;
      this.linkConsultaNacional = this.isEmissaoTesteValidacao
        ? 'https://www.producaorestrita.nfse.gov.br/ConsultaPublica/?tpc=1&chave=' + chaveNfseNacional
        : 'https://www.nfse.gov.br/ConsultaPublica/?tpc=1&chave=' + chaveNfseNacional;
      this.displayDanfse = true;
    },
    copiarPix() {
      navigator.clipboard.writeText(this.pixGerado.qrCode);
    },
    copiarChaveNacional() {
      navigator.clipboard.writeText(this.chaveNotaNacional);
    },
    pesquisar() {
      this.erros = [];
      console.log(this.selectedIntermediario);
      this.processando(true);

      if (!this.dataFatoGeradorIni) {
        this.dataFatoGeradorIni = null;
      }
      if (!this.dataFatoGeradorFim) {
        this.dataFatoGeradorFim = null;
      }
      const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService;
      servicoAtivo
        .listAllFiltroPesquisar(
          this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : '',
          this.selectedIntermediario && this.selectedIntermediario.documento
            ? this.selectedIntermediario.documento
            : '',
          this.filtroNumero,
          this.filtroRpsNumero,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          this.notaAvulsa == true ? 'S' : 'N',
          this.filtroSituacao ? this.filtroSituacao.key : 'T',
          this.aliquota,
        )
        .then((response) => {
          this.nfseList = response;
        })
        .then(() => {
          this.processando(false);
        });
    },

    visualizarDanfse(idNota) {
      this.processando(true);
      const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService;
      servicoAtivo.downloadDanfseHtml(idNota)
        .then((response) => {
          const html = response.data;
          ReportService.openHtmlFromBytes(html);
        })
        .catch((error) => {
          this.$root.$emit('alert:warn', 'Erro ao efetuar o download da DANFSE!');
          console.error('Erro ao efetuar o download da DANFSE:', error);
        })
        .then(() => {
          this.processando(false);
        });
    },

    visualizar(nfseId, numeroNfse) {
      this.processando(true);

      let nomeRel = this.isEmissaoTesteValidacao
        ? 'NotaFiscalEletronicaTeste'
        : this.observacaoClienteNfse
        ? 'NotaFiscalEletronicaObs'
        : 'NotaFiscalEletronica';

      ReportService.imprimir(nomeRel, [
        {
          param: 'where',
          string: " and nota_fiscal.id = '" + nfseId + "' ",
        },
        {
          param: 'numeroNota',
          string: numeroNfse + ' ',
        },
        {
          param: 'ID_CONTRIBUINTE',
          string: this.currentUser.contribuinte.idContribuinte,
        },
        {
          param: 'apresentacao',
          string: this.apresentacao ? 'S' : 'N',
        },
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    download(nfseId) {
      this.processando(true);

      let nomeRel = this.isEmissaoTesteValidacao
        ? 'NotaFiscalEletronicaTeste'
        : this.observacaoClienteNfse
        ? 'NotaFiscalEletronicaObs'
        : 'NotaFiscalEletronica';

      ReportService.download(nomeRel, [
        {
          param: 'where',
          string: " and nota_fiscal.id = '" + nfseId + "' ",
        },
        {
          param: 'apresentacao',
          string: this.apresentacao ? 'S' : 'N',
        },
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao efetuar o download!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    downloadXml(nfseId) {
      this.processando(true);

      if(this.isEmissaoTesteValidacao){
        NotaFiscalTesteService.downloadXml(nfseId)
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao efetuar o download!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
      }else{
        ReportService.downloadXml(nfseId)
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao efetuar o download!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
      }
    },
    imprimirExcel() {
      this.imprimirConsultaTipo('xls');
    },
    imprimirConsultaTipo(tipo) {
      this.processando(true);
      let ID_CNT_PRESTADOR =
        this.filtroEmissao.key === 'P'
          ? this.currentUser.contribuinte.idContribuinte
          : this.selectedPrestador
          ? this.selectedPrestador.idContribuinte
          : null;
      let DOC_TOMADOR = this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : null;
      ReportService.imprimir(
        'ConsultaNotaFiscalXls',
        [
          {
            param: 'ID_CNT_PRESTADOR',
            string: ID_CNT_PRESTADOR,
          },
          {
            param: 'DOC_TOMADOR',
            string: DOC_TOMADOR,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
          },
          {
            param: 'ID_CLIENTE',
            string: this.currentUser.usuario.idCliente,
          },
        ],
        tipo,
      )
        .then(
          () => {},
          (error) => {
            if (error.response && error.response.data instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const result = JSON.parse(reader.result);
                  this.$root.$emit('alert:warn', result.message || result);
                } catch (e) {
                  this.$toast.add({
                    group: 'cb',
                    severity: 'warn',
                    summary: 'Aviso',
                    detail: reader.result,
                    life: 15000,
                  });
                }
              };
              reader.readAsText(error.response.data);
            } else if (error.response && error.response.data) {
              this.$root.$emit('alert:warn', error.response.data);
            } else {
              this.$root.$emit('alert:warn', 'Erro inesperado na impressão.');
            }
          },
        )
        .then(() => {
          this.processando(false);
        });
    },
    imprimirRelacaoChaveValidacao() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir('RelacaoChavesValidacao', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
        ])
          .then(
            () => {},
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao Imprimir!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },
    imprimirLivroFiscal() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir('LivroFiscal', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
          {
            param: 'NOME_PRESTADOR',
            string: this.currentUser.contribuinte.nome,
          },
          {
            param: 'CNPJ_PRESTADOR',
            string: this.currentUser.contribuinte.documento,
          },
          {
            param: 'NOME_EMPRESA',
            string: this.currentUser.usuario.nomeCliente,
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
          },
          {
            param: 'ORDER_BY',
            string:
              this.currentUser.usuario.idCliente === '25bb3c25-8e48-4dbe-8c1f-68b74553188c'
                ? 'nota.data_fato_gerador'
                : 'nota.id_cnt_prestador, nota.ano, nota.mes, nota.numero',
          },
        ])
          .then(
            () => {},
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao Imprimir!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    imprimirConsultaNotaFiscal() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }
      if (!msg) {
        this.processando(true);
        ReportService.imprimir('ConsultaNotaFiscal', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
          },
          {
            param: 'DOC_TOMADOR',
            string: this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : null,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
          {
            param: 'P_DETALHADO',
            string: 'S',
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
          },
          {
            param: 'ID_CLIENTE',
            string: this.currentUser.usuario.idCliente,
          },
        ])
          .then(
            () => {},
            (error) => {
              if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                  try {
                    const result = JSON.parse(reader.result);
                    this.$root.$emit('alert:warn', result.message || result);
                  } catch (e) {
                    this.$toast.add({
                      group: 'cb',
                      severity: 'warn',
                      summary: 'Aviso',
                      detail: reader.result,
                      life: 15000,
                    });
                  }
                };
                reader.readAsText(error.response.data);
              } else if (error.response && error.response.data) {
                this.$root.$emit('alert:warn', error.response.data);
              } else {
                this.$root.$emit('alert:warn', 'Erro inesperado na impressão.');
              }
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    imprimirConsultaNotasCanceladas() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }
      if (!msg) {
        this.processando(true);
        ReportService.imprimir('ConsultaNotaFiscalCanceladas', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
          },
          {
            param: 'DOC_TOMADOR',
            string: this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : null,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
          {
            param: 'P_DETALHADO',
            string: 'S',
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
          },
          {
            param: 'ID_CLIENTE',
            string: this.currentUser.usuario.idCliente,
          },
        ])
          .then(
            () => {},
            (error) => {
              if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                  try {
                    const result = JSON.parse(reader.result);
                    this.$root.$emit('alert:warn', result.message || result);
                  } catch (e) {
                    this.$toast.add({
                      group: 'cb',
                      severity: 'warn',
                      summary: 'Aviso',
                      detail: reader.result,
                      life: 15000,
                    });
                  }
                };
                reader.readAsText(error.response.data);
              } else if (error.response && error.response.data) {
                this.$root.$emit('alert:warn', error.response.data);
              } else {
                this.$root.$emit('alert:warn', 'Erro inesperado na impressão.');
              }
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    imprimirDanfseAgrupadas() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }

      if (!msg) {
        this.processando(true);

        NotaFiscalService.downloadDanfseHtmlAgrupadas(
          this.currentUser.usuario.idCliente,
          this.currentUser.contribuinte.idContribuinte,
          this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : null,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
        )
          .then((response) => {
            const html = response.data;
            ReportService.openHtmlFromBytes(html);
          })
          .catch((error) => {
            this.$root.$emit(
              'alert:warn',
              error.response && error.response.data ? error.response.data : 'Erro ao efetuar o download da DANFSE!',
            );
            console.error('Erro ao efetuar o download da DANFSE:', error);
          })
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    imprimirNotaFiscalAgrupadas() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir('NotaFiscalAgrupadas', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
          },
          {
            param: 'DOC_TOMADOR',
            string: this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : null,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
          },
          {
            param: 'ID_CLIENTE',
            string: this.currentUser.usuario.idCliente,
          },
        ])
          .then(
            () => {},
            (error) => {
              if (error.response && error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.onload = () => {
                  try {
                    const result = JSON.parse(reader.result);
                    this.$root.$emit('alert:warn', result.message || result);
                    console.log('Erro1:', result);
                  } catch (e) {
                    this.$toast.add({
                      group: 'cb',
                      severity: 'warn',
                      summary: 'Aviso',
                      detail: reader.result,
                      life: 15000,
                    });
                    // this.$root.$emit("alert:warn", reader.result);
                    console.log('Erro2:', reader.result);
                  }
                };
                reader.readAsText(error.response.data);
              } else if (error.response && error.response.data) {
                this.$root.$emit('alert:warn', error.response.data);
                console.log('Erro3:', error.response.data);
              } else {
                this.$root.$emit('alert:warn', 'Erro inesperado na impressão.');
                console.log('Erro inesperado:', error);
              }
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    imprimirConsultaNotaFiscalAvulsaDam() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir('ConsultaNotaFiscalAvulsaDam', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
          },
          {
            param: 'DOC_TOMADOR',
            string: this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : null,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
          {
            param: 'P_DETALHADO',
            string: 'S',
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
          },
        ])
          .then(
            () => {},
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao Imprimir!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    imprimirNotaFiscalAvulsaAgrupadas() {
      var msg = null;
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir('NotaFiscalAgrupadas', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
          },
          {
            param: 'DOC_TOMADOR',
            string: this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : null,
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
          },
        ])
          .then(
            () => {},
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao Imprimir!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    imprimirRelacaoRetencoesNfse() {
      var msg = null;
      console.log(this.dataFatoGeradorIni);
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = 'É necessário informar o contribuinte!';
      } else if (!this.dataFatoGeradorIni) {
        msg = 'É necessário informar a data Inicial!';
      } else if (!this.dataFatoGeradorFim) {
        msg = 'É necessário informar a data Final!';
      }

      if (!msg) {
        this.processando(true);
        ReportService.imprimir('ConsultaRetencoesNfse', [
          {
            param: 'ID_CNT_PRESTADOR',
            string: this.currentUser.contribuinte.idContribuinte,
            // string: "bba1a08b-6ba2-480e-b134-8a5f61ca727a"
          },
          {
            param: 'DATA_INICIAL',
            date: this.dataFatoGeradorIni,
            // date: '2018-01-01'
          },
          {
            param: 'DATA_FINAL',
            date: this.dataFatoGeradorFim,
            // date: '2024-12-02'
          },
          {
            param: 'P_SITUACAO',
            string: this.filtroSituacao && this.filtroSituacao.key != 'T' ? this.filtroSituacao.key : null,
            // string: ""
          },
        ])
          .then(
            () => {},
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao Imprimir!');
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit('alert:warn', msg);
      }
    },

    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await PessoaService.findAllByConttribuinteFiltro(event.query, '');
      }, 550);
    },

    searchIntermediario(event) {
      setTimeout(async () => {
        this.filteredIntermediario = await PessoaService.findAllByConttribuinteFiltro(event.query, '');
        console.log(this.filteredIntermediario);
      }, 550);
    },

    enviarEmail(id) {
      if (id) {
        this.$root.$emit('notaFiscal:enviarEmail', id);
      }
    },

    cartaCorrecaoNotaFiscal(nota) {
      if (nota) {
        NotaFiscalService.findById(nota.id).then((response) => {
          nota = response.data;
          this.$root.$emit('notaFiscal:cartaCorrecao', nota);
        });
      }
    },

    consultaDeclaracoesNfse(id) {
      let tipo = 'N';
      if (id) {
        this.$root.$emit('notaFiscal:consultaDeclaracoes', tipo, id);
      }
    },

    cancelarNotaFiscal(nota) {
      //especifico joao monlevade
      let idCliente = '6866f81d-967e-4808-bb27-0dcf85594275'; //""
      let cancelamentoCienciaTomador =
        (this.currentUser.configuracao.nfCancelamentoCienciaTomador &&
          this.currentUser.configuracao.nfCancelamentoCienciaTomador === 'S') ||
        false;
      if (cancelamentoCienciaTomador && this.currentUser.usuario.idCliente === idCliente) {
        var totalDiasCancelamento = 60;
        let dataEmissao = this.moment(nota.dataFatoGerador).format('YYYY-MM-DD');
        var dataLimiteCancelamento = new Date(dataEmissao);
        dataLimiteCancelamento.setDate(dataLimiteCancelamento.getDate() + totalDiasCancelamento);
        var dataAtual = new Date();
        if (dataAtual > dataLimiteCancelamento) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Cancelamento Não Permitido',
            detail:
              'O prazo de 60 dias para Cancelamento da Nota Fiscal foi excedido. Não é possível Cancelar ou emitir Termo de Cancelamento para essa Nota Fiscal.',
            life: 10000,
          });
          return;
        }
      }
      if (nota) {
        const notaFiscal = {
          id: nota.id,
          dataGeracao: nota.dataFatoGerador,
          validacao: true,
          cancDamPetrolina: this.cancDamPetrolina,
          isEmissaoTesteValidacao: this.isEmissaoTesteValidacao,
        };

        this.$root.$emit('notaFiscal:cancelar', notaFiscal);
      }
    },

    exportar() {
      this.$root.$emit('notaFiscal:exportar');
    },

    cancelarNotaFiscalDireta(nota) {
      if (nota) {
        const notaFiscal = {
          id: nota.id,
          dataGeracao: nota.dataFatoGerador,
          validacao: false,
          cancDamPetrolina: this.cancDamPetrolina,
          isEmissaoTesteValidacao: this.isEmissaoTesteValidacao,
        };

        this.$root.$emit('notaFiscal:cancelar', notaFiscal);
      }
    },

    substituirNotaFiscal(nota) {
      this.processando(true);
      this.erros = [];
      let dataEmissao = this.moment(nota.dataFatoGerador).format('YYYY-MM-DD');

      //especifico joao monlevade
      let idCliente = '6866f81d-967e-4808-bb27-0dcf85594275'; //""
      let cancelamentoCienciaTomador =
        (this.currentUser.configuracao.nfCancelamentoCienciaTomador &&
          this.currentUser.configuracao.nfCancelamentoCienciaTomador === 'S') ||
        false;
      if (cancelamentoCienciaTomador && this.currentUser.usuario.idCliente === idCliente) {
        var totalDiasSubstituicao = 60;
        var dataLimiteSubstituicao = new Date(dataEmissao);
        dataLimiteSubstituicao.setDate(dataLimiteSubstituicao.getDate() + totalDiasSubstituicao);
        var dataAtual = new Date();
        if (dataAtual > dataLimiteSubstituicao) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Substituição Não Permitida',
            detail:
              'O prazo de 60 dias para Substituição da Nota Fiscal foi excedido. Não será possível Substituir a Nota Fiscal.',
            life: 10000,
          });
          this.processando(false);
          return;
        }
      }
      const servicoAtivo = this.isEmissaoTesteValidacao ? NotaFiscalTesteService : NotaFiscalService;
      servicoAtivo
        .validarSubstituicaoNotaFiscal(nota.id, nota.valorServico, dataEmissao)
        .then(
          (data) => {
            if (data.data.length) {
              this.erros.push(...data.data);
            } else {
              this.$router.push({
                name: this.isEmissaoTesteValidacao ? 'emissaoNfseTeste' : 'emissaoNfse',
                params: {
                  dadosSubstituicao: {
                    id: nota.id,
                    numero: nota.numero,
                    data: nota.dataGeracaoFormatada,
                    tomador: nota.tomadorDadosDetail,
                    copiaNota: false,
                  },
                },
              });
            }
          },
          (error) => {
            console.log(error);
            this.nfseId = nota.id;
            this.mensagemSubstituicaoPrazo = error.response.data;
            this.obsSubstituicao = '';
            this.showBloqSubstituicaoNota = true;
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    confirmaDesfazerCancelamento(id) {
      this.nfseId = id;
      this.displayAtivaNota = true;
    },

    desfazerCancelamento() {
      if (this.nfseId) {
        this.processando(true);

        NotaFiscalService.desfazerCancelamento(this.nfseId)
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.displayAtivaNota = false;
              this.$root.$emit('alert:success', 'Nota Fiscal reativada com sucesso!');
            },
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao reativar nota fiscal!');
              this.damGerado = 'N';
              console.log(error);
            },
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    analiseCancelamento(nota) {
      this.processando(true);

      NotaFiscalService.validarAnaliseCancelamentoNfse(nota.id)
        .then(
          (response) => {
            const dadosNotaFiscal = {
              nota: nota,
              notaSituacao: response.data,
              statusTomador: null,
              observacaoTomador: null,
            };
            this.$root.$emit('notaFiscal:analiseCancelamento', dadosNotaFiscal);
          },
          (error) => {
            const erro = error.response.data;

            if (erro) {
              this.$root.$emit('alert:warn', erro);
            }
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    detail(nfseId) {
      this.$router.push({ name: 'emissaoNfse', params: { id: nfseId } });
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },

    verificaDamGerado() {
      this.processando(true);
      console.log('Verifica Dam Gerado!!' + this.idNotaAvulsaSelecionada);
      NotaFiscalAvulsaService.verificaDamGerado(this.idNotaAvulsaSelecionada)
        .then(
          (response) => {
            this.damGerado = response.data;
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao verificar DAM!');
            this.damGerado = 'N';
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },

    gerarDamNotaAvulsa() {
      if (!this.dataVencimento) {
        this.$root.$emit('alert:warn', 'Data de Vencimento Obrigatória!');
        return;
      }
      this.processando(true);
      console.log('Gerar DAM nf: ' + this.idNotaAvulsaSelecionada + ' Vencimento: ' + this.dataVencimento);
      NotaFiscalAvulsaService.gerarDamNotaAvulsa(this.idNotaAvulsaSelecionada, this.dataVencimento)
        .then(
          (response) => {
            this.$root.$emit('alert:success', 'DAM gerado com sucesso!');
            console.log(response);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao gerar o DAM!');
            console.log(error);
          },
        )
        .then(() => {
          this.verificaDamGerado();
          this.processando(false);
        });
    },
    cancelarDamNotaAvulsa() {
      this.processando(true);
      console.log('Cancelar DAM nf: ' + this.idNotaAvulsaSelecionada);
      NotaFiscalAvulsaService.cancelarDamNotaAvulsa(this.idNotaAvulsaSelecionada)
        .then(
          (response) => {
            this.$root.$emit('alert:success', 'DAM cancelado com sucesso!');
            console.log(response);
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao cancelar o DAM!');
            console.log(error);
          },
        )
        .then(() => {
          this.verificaDamGerado();
          this.processando(false);
        });
    },
    carregarVencimentoBoleto(dataEmissaoNfse, id) {
      let d = this.currentUser.configuracao.diaVencimento;
      let arrayOfData = dataEmissaoNfse.split('-');
      let dataEmissao = new Date(arrayOfData[0], arrayOfData[1] - 1, d);
      let dataAtual = new Date();
      let data = new Date(dataEmissao.getFullYear(), dataEmissao.getMonth(), d);
      let mes = data.getMonth() + 1;
      data.setMonth(mes);
      if (dataAtual > data) {
        this.dataVencimento = dataAtual;
      } else {
        this.dataVencimento = data;
      }
      this.idNotaAvulsaSelecionada = id;
      this.verificaDamGerado();
      this.displayVencBoleto = true;
    },
    hideVencBoleto() {
      this.displayVencBoleto = false;
      this.idNotaAvulsaSelecionada = null;
    },
    imprimirBoleto() {
      if (!this.dataVencimento) {
        this.$root.$emit('alert:warn', 'Data de Vencimento Obrigatória!');
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(this.idNotaAvulsaSelecionada, this.dataVencimento)
        .then(
          (response) => {
            console.log(response.data);
            let idGerado = response.data;
            ReportService.imprimir('trb_dam_a5', [
              {
                param: 'RP_ID_CLIENTE',
                string: this.currentUser.usuario.idCliente,
              },
              {
                param: 'P_CONTROLE_PARCELA',
                string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
              },
            ]).then(
              (data) => {
                console.log(data);
              },
              (error) => {
                this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
                console.log(error);
              },
            );
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao atualizar Vencimento!');
            console.log(error);
          },
        )
        .then(() => {
          this.hideVencBoleto();
          this.processando(false);
        });
    },
    criarPagamentoPix() {
      this.processando(true);
      NotaFiscalAvulsaService.criarPagamentoPix(this.idNotaAvulsaSelecionada)
        .then(
          (response) => {
            console.log(response);
            this.pixGerado = response.data;
            this.optionsPix.data = this.pixGerado.qrCode;
            this.showPix = true;
          },
          (error) => {
            this.pixGerado = null;
            this.$root.$emit('alert:warn', error);
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },
    consultarPagamentoPix() {
      if (this.idNotaAvulsaSelecionada) {
        this.processando(true);
        NotaFiscalAvulsaService.consultarPagamentoPix(this.idNotaAvulsaSelecionada)
          .then(
            (response) => {
              console.log(response);
              this.hideVencBoleto();
              this.showPix = false;
              this.pesquisar();
              this.$root.$emit('alert:info', response.data);
            },
            (error) => {
              console.log(error);
              this.$root.$emit('alert:warn', error.response.data);
            },
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    imprimirBoletoPix() {
      if (!this.dataVencimento) {
        this.$root.$emit('alert:warn', 'Data de Vencimento Obrigatória!');
        return;
      }
      this.processando(true);
      NotaFiscalAvulsaService.atualizarVencimento(this.idNotaAvulsaSelecionada, this.dataVencimento)
        .then(
          (response) => {
            console.log(response);
            let idGerado = response.data;
            NotaFiscalAvulsaService.criarPagamentoPixCp(this.idNotaAvulsaSelecionada, idGerado)
              .then(
                (response) => {
                  console.log(response);
                  this.pixGerado = response.data;
                  ReportService.imprimir('trb_dam_a5_pix', [
                    {
                      param: 'RP_ID_CLIENTE',
                      string: this.currentUser.usuario.idCliente,
                    },
                    {
                      param: 'QR_CODE',
                      string: this.pixGerado.qrCode,
                    },
                    {
                      param: 'P_CONTROLE_PARCELA',
                      string: " and cp.id_situacao in('1','4','6')  and  cp.id in ('" + idGerado + "')",
                    },
                  ]).then(
                    (data) => {
                      console.log(data);
                    },
                    (error) => {
                      this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
                      console.log(error);
                    },
                  );
                },
                (error) => {
                  this.pixGerado = null;
                  this.$root.$emit('alert:warn', error);
                  console.log(error);
                },
              )
              .then(() => {
                this.showEscolhaPix = false;
                this.processando(false);
              });
          },
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao atualizar Vencimento!');
            console.log(error);
          },
        )
        .then(() => {
          this.hideVencBoleto();
          this.processando(false);
        });
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    exibirEmissaoDam(damPago, situacao, idBolDevedorContumaz, notaAvulsa) {
      let exibir = idBolDevedorContumaz === 'S' || notaAvulsa === 'S';
      return exibir && damPago != 'S' && damPago != 'L' && situacao != 'Cancelada' ? true : false;
    },
    exibirImpressao(damPago, notaAvulsa) {
      if (!notaAvulsa || notaAvulsa === 'N') {
        return true;
      } else if (
        damPago == 'S' ||
        damPago === 'L' ||
        damPago === 'D' ||
        this.currentUser.configuracao.idBolNtAvulsaSemPgto === 'E'
      ) {
        return true;
      }
      return false;
    },
    exibirExportarXml(damPago, idBolDevedorContumaz) {
      if (this.isEmissaoTesteValidacao) {
        return true;
      } else if (!this.notaAvulsa && idBolDevedorContumaz === 'S') {
        return damPago === 'S' || damPago === 'L' ? true : false;
      } else if (!this.notaAvulsa) {
        return true;
      } else if (this.notaAvulsa && (damPago == 'S' || damPago === 'L' || damPago === 'D')) {
        return true;
      }
      return false;
    },
    exibirEnviarEmail(damPago, idBolDevedorContumaz) {
      if (this.isEmissaoTesteValidacao) {
        return false;
      } else if (!this.notaAvulsa && idBolDevedorContumaz === 'S') {
        return damPago === 'S' || damPago === 'L' ? true : false;
      } else if (!this.notaAvulsa) {
        return true;
      } else if (this.notaAvulsa && (damPago == 'S' || damPago === 'L' || damPago === 'D')) {
        return true;
      }
      return false;
    },
    exibirBotaoCartaCorrecao(damPago, idBolDevedorContumaz, admin) {
      if (this.isEmissaoTesteValidacao) {
        return false;
      } else if (!this.notaAvulsa && idBolDevedorContumaz === 'S') {
        return damPago === 'S' || damPago === 'L' ? true : false;
      } else if (!this.notaAvulsa) {
        return true;
      } else if (this.notaAvulsa && (damPago !== 'S' || admin)) {
        return true;
      }
      return false;
    },
    exibirBotaoCancelamento(damPago, admin) {
      if (this.notaAvulsa && damPago === 'S' && !admin) {
        return false;
      }
      return true;
    },
    exibeIntermediario() {
      if (this.currentUser.configuracao.idBolIntermediario && this.currentUser.configuracao.idBolIntermediario == 'S') {
        this.showFilterIntermediario = true;
      } else {
        this.showFilterIntermediario = false;
      }
    },
    emitirTermo() {
      this.processando(true);
      NotaFiscalService.termoSubstituicao(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.nfseId,
        this.obsSubstituicao,
      )
        .then((response) => {
          console.log(response);
          ReportService.imprimir('TermoCancelamento', [
            {
              param: 'id',
              string: this.nfseId,
            },
            {
              param: 'tipo',
              string: 'S',
            },
          ]).then(
            () => {},
            (error) => {
              this.$root.$emit('alert:warn', 'Erro ao Imprimir!');
              console.log(error);
            },
          );
        })
        .then(() => {
          this.processando(false);
        });
    },
  },

  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
    isEmissaoTesteValidacao() {
      return this.testeValidacao;
    },
  },
};
</script>

<style src="../assets/css/consultaNfse.css"></style>
